/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PageScrapbookLinkForRequestLogsQueryVariables = GraphQL.Exact<{
  legacyUrlId: GraphQL.Scalars['Int']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type PageScrapbookLinkForRequestLogsQuery = { readonly __typename?: 'Query', readonly lookupPageByLegacyId: { readonly __typename?: 'Page', readonly id: CK.UrlId, readonly scrapbookLinkForRequestLogs: string | null } | null };


export const PageScrapbookLinkForRequestLogsDocument = gql`
    query PageScrapbookLinkForRequestLogs($legacyUrlId: Int!, $websiteId: WebsiteId!) {
  lookupPageByLegacyId(legacyUrlId: $legacyUrlId, websiteId: $websiteId) {
    id
    scrapbookLinkForRequestLogs
  }
}
    `;

/**
 * __usePageScrapbookLinkForRequestLogsQuery__
 *
 * To run a query within a React component, call `usePageScrapbookLinkForRequestLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageScrapbookLinkForRequestLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageScrapbookLinkForRequestLogsQuery({
 *   variables: {
 *      legacyUrlId: // value for 'legacyUrlId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function usePageScrapbookLinkForRequestLogsQuery(baseOptions: Apollo.QueryHookOptions<PageScrapbookLinkForRequestLogsQuery, PageScrapbookLinkForRequestLogsQueryVariables> & ({ variables: PageScrapbookLinkForRequestLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageScrapbookLinkForRequestLogsQuery, PageScrapbookLinkForRequestLogsQueryVariables>(PageScrapbookLinkForRequestLogsDocument, options);
      }
export function usePageScrapbookLinkForRequestLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageScrapbookLinkForRequestLogsQuery, PageScrapbookLinkForRequestLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageScrapbookLinkForRequestLogsQuery, PageScrapbookLinkForRequestLogsQueryVariables>(PageScrapbookLinkForRequestLogsDocument, options);
        }
export function usePageScrapbookLinkForRequestLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageScrapbookLinkForRequestLogsQuery, PageScrapbookLinkForRequestLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageScrapbookLinkForRequestLogsQuery, PageScrapbookLinkForRequestLogsQueryVariables>(PageScrapbookLinkForRequestLogsDocument, options);
        }
export type PageScrapbookLinkForRequestLogsQueryHookResult = ReturnType<typeof usePageScrapbookLinkForRequestLogsQuery>;
export type PageScrapbookLinkForRequestLogsLazyQueryHookResult = ReturnType<typeof usePageScrapbookLinkForRequestLogsLazyQuery>;
export type PageScrapbookLinkForRequestLogsSuspenseQueryHookResult = ReturnType<typeof usePageScrapbookLinkForRequestLogsSuspenseQuery>;
export type PageScrapbookLinkForRequestLogsQueryResult = Apollo.QueryResult<PageScrapbookLinkForRequestLogsQuery, PageScrapbookLinkForRequestLogsQueryVariables>;